import gql from 'graphql-tag';
import HelperGraphql from "utils/helper-graphql";
import FieldsRoom from "graphql/fields/FieldsRoom";
import FieldsTimeslot from 'graphql/fields/FieldsTimeslot'

const fields = {
	'guid': 'String!',
};

export default gql(`
	query room( ${ HelperGraphql.createFields( fields ) } ) {
		room( ${ HelperGraphql.createVariables( fields ) } ) {
			${FieldsRoom}
			
			floor {
				guid
				
				building {
					guid
				}
			}
			
			timeslots {
				timeslot {
					${FieldsTimeslot}
				}
			}
			
		    available_for_teams {
	            team {
	                guid
	                name
	            }
	        }
			
		    available_for_employees {
	            employee {
	                guid
	                name
	                department{
						name
					}
					team{
						name
					}
	            }
	        }
		}
	}
`);

